import { CONTRACT_FORM_FIELD_NAME_BUILDING } from '../../../Contract.constants'

export function getContractFlatApiParams(values) {
  return {
    archived: false,
    building: values[CONTRACT_FORM_FIELD_NAME_BUILDING]?.value,
  }
}
